// extracted by mini-css-extract-plugin
export default {"card":"wla-z","isSwatchGrouping":"xla-z"};